import { useTheme } from '@mui/material/styles';
import { Box, Container, useMediaQuery } from '@mui/material';

function SimBContainer({ children, sx, bgImage = '', bgSx = {}, ...other }) {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('lg'));
  return (!bgImage) ? (
    <Container
      disableGutters
      sx={{
        position: 'relative',
        ...sx
      }}
      maxWidth={'lg'}
      { ...other }
    >
      { children }
    </Container>
  ) : (
    <Box
      sx={{
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundOrigin: 'border-box',
        backgroundSize: 'cover',
        backgroundImage: `url(${bgImage})`,
        ...bgSx,
      }}
    >
      <Container
        disableGutters
        sx={{
          position: 'relative',
          ...sx
        }}
        maxWidth={'lg'}
        { ...other }
      >
        { children }
      </Container>
    </Box>
  )
};

export default SimBContainer;
